import React from 'react';
import {useStyle} from './helper'
import {useRouter} from '../../../../../@casino/useRouter';
import { format } from 'date-fns';

const MailingItem = (props) => {
    console.log(props);
    const classes = useStyle();
    const router = useRouter();
    const mailing_date_at = format(new Date(Number(props?.mailing_date_at)), 'dd.MM.yyyy');

    return (
        <div 
            className={classes.root} 
            onClick={() => router.history.push(`/mailing/view/${props.id}/general`)}
        >
            <span className={classes.online}>{mailing_date_at}</span>
            <div className={classes.wrapLogin}>
                <span>{props?.label}</span>
            </div>
            <div className={classes.wrapLogin}>
                <span>{props?.description}</span>
            </div>
        </div>
    )
}

export default MailingItem;